import {useIntl} from 'react-intl'
import { useReferral } from '../../hook'

const Point = ({Field, setFieldValue}: any) => {
  const intl = useIntl()

  return (
    <>
      <div className='d-flex align-items-center gap-3 mt-5'>
        <Field
          type='radio'
          id='campaignType'
          name='campaignType'
          className='form-check-input'
          value='1'
          onChange={() => {
            setFieldValue('campaignType', '1')
            setFieldValue('priceCluster', [])
            setFieldValue('points', '')
            setFieldValue('spent', '')
          }}
        />
        <div className='fs-6'>{intl.formatMessage({id: 'CAMPAIGN.POINT.INCREMENTAL'})}</div>
      </div>
      <div className='d-flex align-items-center gap-3 mt-5'>
        <Field
          type='radio'
          id='campaignType'
          name='campaignType'
          className='form-check-input'
          value='2'
          onChange={() => {
            setFieldValue('campaignType', '2')
            setFieldValue('priceCluster', [])
            setFieldValue('points', '')
            setFieldValue('spent', '')
          }}
        />
        <div className='fs-6'>{intl.formatMessage({id: 'CAMPAIGN.POINT.FIXED'})}</div>
      </div>
    </>
  )
}

const Discount = ({Field, setFieldValue}: any) => {
  const intl = useIntl()
  const {selectedGiveAwayProductSet} = useReferral()

  const ruleList = [
    {
      // label: 'Amount Off - % Off',
      label: intl.formatMessage({id: 'DISCOUNT.AMOUNT_OFF_PERCENT_OFF'}),
      value: '1',
    },
    {
      label: intl.formatMessage({id: 'DISCOUNT.FIX_PRICE_PER_UNIT'}),
      value: '2',
    },
    {
      // label: 'Bundle Set Discount',
      label: intl.formatMessage({id: 'DISCOUNT.BUNDLE_SET_DISCOUNT'}),
      value: '3',
    },
    {
      // label: 'Bulk/Tiered Discount',
      label: intl.formatMessage({id: 'DISCOUNT.BULK_TIERED_DISCOUNT'}),
      value: '4',
    },
    {
      // label: 'Buy X Get X',
      label: intl.formatMessage({id: 'DISCOUNT.BUY_X_GET_X'}),
      value: '5',
    },
    {
      // label: 'Buy X Get Y',
      label: intl.formatMessage({id: 'DISCOUNT.BUY_X_GET_Y_AMOUNT'}),
      value: '6',
    },
    {
      // label: 'Buy X Get Y (Amount)',
      label: intl.formatMessage({id: 'DISCOUNT.BUY_X_GET_Y_QUANTITIY'}),
      value: '15',
    },
    // {label: 'Store Wide Discount', value: '4'},
    // {label: 'Specific Product Discount', value: '5'},
    // {label: 'Buy X Get Y (Category)', value: '7'},
  ]
  return (
    <>
      <div className='row'>
        {ruleList.map((rule, index) => {
          return (
            <div className='col-md-6' key={index}>
              <div className='d-flex align-items-center gap-3 mt-5' key={index}>
                <Field
                  type='radio'
                  name='promoGroup'
                  id={`promoGroup-${rule.value}`}
                  className='form-check-input'
                  value={rule.value}
                  onChange={(e: any) => {
                    setFieldValue('promoGroup', e.target.value)
                    setFieldValue('priceCluster', [])
                    selectedGiveAwayProductSet([])

                    //2, 3, 5
                    if (rule.value.includes('2') || rule.value.includes('3') || rule.value.includes('5') || rule.value.includes('6')) {
                      setFieldValue('productInSelectionType', '2')
                    }
                  }}
                />
                <label className='fs-6' htmlFor={`promoGroup-${rule.value}`}>
                  {rule.label}
                </label>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default function useCampaignTypes() {
  const sectionRender = (Field: any, values: any, setFieldValue: any) => {
    switch (values.promoCluster) {
      case '2':
        return <Point Field={Field} setFieldValue={setFieldValue} />
      case '1':
        return <Discount Field={Field} setFieldValue={setFieldValue} />
      default:
        return
    }
  }
  return {sectionRender}
}
